<template>
    <ul @click="menuBack">
        <li class="ttl">出発地</li>
        <li class="item">
            <span class="item1">{{displayPref}}</span>
            <span class="ar">&gt;</span>
            <span class="item2">{{displayTarget}}</span>
        </li>
        <li class="arrow"><img loading="lazy" src="/user/assets/images/common/arrow_b.png"></li>
    </ul>

    <div id="sb-destination" class="slidemenu" v-show="isFirstShow">

        <ul class="slide-close">
            <li class="close_btn"><span class="close_btn_txt" @click="menuBack">戻る</span></li>
            <li class="list-title">スキー場選択</li>
        </ul>

        <ul id="destination_area_form" class="list-bar" v-show="isAreaShow" style="display:block;">
            <li v-for="(value, key) in destinationAreaItemList" :value="key" @click="selectArea(key)">
                {{ value.name }}エリア
            </li>

            <div class="sp-btn-reset">
                <button type="button" @click="reset">出発地条件をリセット</button>
            </div>
        </ul>

        <ul id="destination_pref_form" class="list-bar" v-show="isPrefShow" style="display:block;">
            <li v-for="(value, key) in destinationPrefItemList" :value="key" @click="selectPref(key)" v-show="value.parentIdList[condition.selectedDestinationArea.value] || !condition.selectedDestinationArea.value">
                {{ value.name }}
            </li>

            <div class="sp-btn-reset">
                <button type="button" @click="reset">出発地条件をリセット</button>
            </div>
        </ul>

        <ul id="destination_form" class="list-bar" v-show="isTargetShow" style="display:block;">
            <li v-for="(value, key) in destinationItemList" :value="key" @click="selectTarget(key)" v-show="value.parentIdList[condition.selectedDestinationPref.value] || !condition.selectedDestinationPref.value">
                {{ value.name }}
            </li>

            <div class="sp-btn-reset">
                <button type="button" @click="reset">出発地条件をリセット</button>
            </div>
        </ul>
    </div>
</template>

<script>
    import { ref, onMounted } from 'vue'
    export default ({
        props: {
            // 引数の受け問
            master : {type: Object, require: true},
            condition : {type: Object, require: true},
        },
        setup (props) {
            const isFirstShow = ref(false)
            const isAreaShow = ref(true)
            const isPrefShow = ref(false)
            const isTargetShow = ref(false)
            const destinationArea = ref(props.condition.selectedDestinationArea.value)
            const displayPref = ref("スキー場を選択してください")
            const displayTarget = ref("")
            const currentMenuPos = ref(0)

            // メソッド実装 押されたとき
            const menuBack = () => {
                if (currentMenuPos.value == 0) {
                    // 未表示
                    isAreaShow.value = true
                    isPrefShow.value = false
                    isTargetShow.value = false
                    isFirstShow.value = true
                    currentMenuPos.value = 1
                } else if(currentMenuPos.value == 1) {
                    // エリア表示
                    isAreaShow.value = false
                    isPrefShow.value = false
                    isTargetShow.value = false
                    isFirstShow.value = false
                    currentMenuPos.value = 0
                } else if(currentMenuPos.value == 2) {
                    // 都道府県表示
                    isAreaShow.value = true
                    isPrefShow.value = false
                    isTargetShow.value = false
                    currentMenuPos.value = 1
                } else if(currentMenuPos.value == 3) {
                    // 出発表示
                    isAreaShow.value = false
                    isPrefShow.value = true
                    isTargetShow.value = false
                    currentMenuPos.value = 2
                }
            }

            // メソッド実装 押されたとき
            const selectArea = (key) => {
                props.condition.selectedDestinationArea.value = key
                isAreaShow.value = false
                isPrefShow.value = true
                isTargetShow.value = false
                currentMenuPos.value = 2
            }

            // メソッド実装 押されたとき
            const selectPref = (key) => {
                props.condition.selectedDestinationPref.value = key
                displayPref.value = destinationPrefItemList[key].name
                isAreaShow.value = false
                isPrefShow.value = false
                isTargetShow.value = true
                currentMenuPos.value = 3

            }

            const selectTarget = (key) => {
                props.condition.selectedDestination.value = key
                displayTarget.value = destinationItemList[key].name + "行き"
                isAreaShow.value = true
                isPrefShow.value = false
                isTargetShow.value = false
                isFirstShow.value = false
                currentMenuPos.value = 0
            }


            const reset = () => {
                props.condition.selectedDestinationArea.value = ""
                props.condition.selectedDestinationPref.value = ""
                props.condition.selectedDestination.value = ""
                displayPref.value = "スキー場を選択してください"
                displayTarget.value = ""

                // 閉じる
                isFirstShow.value = false
                currentMenuPos.value = 0
            }

            // セットアップ。初期実行
            const destinationAreaItemList = JSON.parse(props.master.destinationAreaItemList)
            const destinationPrefItemList = JSON.parse(props.master.destinationPrefItemList)
            const destinationItemList = JSON.parse(props.master.destinationItemList)

            // 完了時
            onMounted(() => {
                if (props.condition.selectedDestinationPref.value) {
                    displayPref.value = destinationPrefItemList[props.condition.selectedDestinationPref.value].name
                }

                if (props.condition.selectedDestination.value) {
                    displayTarget.value = destinationItemList[props.condition.selectedDestination.value].name + "行き"
                }
            })

            return {
                destinationAreaItemList,
                destinationPrefItemList,
                destinationItemList,
                destinationArea,
                isFirstShow,
                isAreaShow,
                isPrefShow,
                isTargetShow,
                menuBack,
                selectArea,
                selectPref,
                selectTarget,
                displayPref,
                displayTarget,
                reset,
            }
        },
    })
</script>